import { atom } from "recoil";
import { Site } from "../../../generated/graphql";

export const sites = atom<Pick<Site, 'id' | 'name'>[] | null>({
    key: 'start_sites', 
    default: null, 
  });